import React from 'react';
import { withCreationHeader } from '@bingads-webui-campaign-react/campaign-adgroup-creation';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { mergeStyles } from '@bingads-webui-campaign-react/common-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { compose } from 'underscore';
import { HotelCampaignBase, scenarios } from './shared';
import { sharedStyles } from './style';

const getStyles = (_, theme) => ({
  ...mergeStyles(
    { theme },
    sharedStyles
  ),
});


export const HotelCampaignCreation = compose(
  withI18nConsumer,
  WrappedComponent => withDefaultStyles(WrappedComponent, getStyles),
  withCreationHeader
)(props => (<HotelCampaignBase {...props} scenario={scenarios.creation} />));
